export default __webpack_public_path__ + "static/planting-1c7f28ab820a887295da3e71df348ce5.webp";